/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.4.0 (NJsonSchema v10.0.21.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(): Promise<string> {
        let url_ = this.baseUrl + "/api/Account/Get/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    testAdmin(): Promise<string> {
        let url_ = this.baseUrl + "/api/Account/TestAdmin/test-admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTestAdmin(_response);
        });
    }

    protected processTestAdmin(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    signIn(request: SignInArguments | null | undefined): Promise<SignInResponse> {
        let url_ = this.baseUrl + "/api/Account/SignIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSignIn(_response);
        });
    }

    protected processSignIn(response: AxiosResponse): Promise<SignInResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignInResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignInResponse>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    createUser(args: CreateUserArgs | null | undefined): Promise<CreateUserResponse> {
        let url_ = this.baseUrl + "/api/Account/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<CreateUserResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserResponse>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    forgottenPassword(args: ForgottenPasswordArgs | null | undefined): Promise<ForgottenPasswordResponse> {
        let url_ = this.baseUrl + "/api/Account/ForgottenPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processForgottenPassword(_response);
        });
    }

    protected processForgottenPassword(response: AxiosResponse): Promise<ForgottenPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForgottenPasswordResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForgottenPasswordResponse>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    forgottenPasswordCode(args: ForgottenPasswordCodeArgs | null | undefined): Promise<ForgottenPasswordCodeResponse> {
        let url_ = this.baseUrl + "/api/Account/ForgottenPasswordCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processForgottenPasswordCode(_response);
        });
    }

    protected processForgottenPasswordCode(response: AxiosResponse): Promise<ForgottenPasswordCodeResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForgottenPasswordCodeResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForgottenPasswordCodeResponse>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    changePassword(args: ChangePasswordArgs | null | undefined): Promise<ChangePasswordResponse> {
        let url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ChangePasswordResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePasswordResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePasswordResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getLegacyToken(): Promise<string> {
        let url_ = this.baseUrl + "/api/LegacyToken/GetLegacyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetLegacyToken(_response);
        });
    }

    protected processGetLegacyToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class SignInArguments implements ISignInArguments {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ISignInArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): SignInArguments {
        data = typeof data === 'object' ? data : {};
        let result = new SignInArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }
}

export interface ISignInArguments {
    email?: string | undefined;
    password?: string | undefined;
}

export class SignInResponse implements ISignInResponse {
    user?: BoatControlUser | undefined;
    token?: string | undefined;
    expires?: number | undefined;

    constructor(data?: ISignInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? BoatControlUser.fromJS(data["user"]) : <any>undefined;
            this.token = data["token"];
            this.expires = data["expires"];
        }
    }

    static fromJS(data: any): SignInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["token"] = this.token;
        data["expires"] = this.expires;
        return data; 
    }
}

export interface ISignInResponse {
    user?: BoatControlUser | undefined;
    token?: string | undefined;
    expires?: number | undefined;
}

export class BoatControlUser implements IBoatControlUser {
    id?: number | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    roles?: string[] | undefined;
    devices?: string[] | undefined;

    constructor(data?: IBoatControlUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.email = data["email"];
            this.fullName = data["fullName"];
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(data["devices"])) {
                this.devices = [] as any;
                for (let item of data["devices"])
                    this.devices!.push(item);
            }
        }
    }

    static fromJS(data: any): BoatControlUser {
        data = typeof data === 'object' ? data : {};
        let result = new BoatControlUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item);
        }
        return data; 
    }
}

export interface IBoatControlUser {
    id?: number | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    roles?: string[] | undefined;
    devices?: string[] | undefined;
}

export class CreateUserArgs implements ICreateUserArgs {
    fullName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateUserArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fullName = data["fullName"];
            this.email = data["email"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): CreateUserArgs {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }
}

export interface ICreateUserArgs {
    fullName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export class CreateUserResponse implements ICreateUserResponse {

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface ICreateUserResponse {
}

export class ForgottenPasswordArgs implements IForgottenPasswordArgs {
    email?: string | undefined;

    constructor(data?: IForgottenPasswordArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
        }
    }

    static fromJS(data: any): ForgottenPasswordArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ForgottenPasswordArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface IForgottenPasswordArgs {
    email?: string | undefined;
}

export class ForgottenPasswordResponse implements IForgottenPasswordResponse {

    constructor(data?: IForgottenPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ForgottenPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForgottenPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IForgottenPasswordResponse {
}

export class ForgottenPasswordCodeArgs implements IForgottenPasswordCodeArgs {
    email?: string | undefined;
    code?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IForgottenPasswordCodeArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.code = data["code"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ForgottenPasswordCodeArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ForgottenPasswordCodeArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["code"] = this.code;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IForgottenPasswordCodeArgs {
    email?: string | undefined;
    code?: string | undefined;
    newPassword?: string | undefined;
}

export class ForgottenPasswordCodeResponse implements IForgottenPasswordCodeResponse {

    constructor(data?: IForgottenPasswordCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ForgottenPasswordCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForgottenPasswordCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IForgottenPasswordCodeResponse {
}

export class ChangePasswordArgs implements IChangePasswordArgs {
    password?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.password = data["password"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordArgs {
    password?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePasswordResponse implements IChangePasswordResponse {

    constructor(data?: IChangePasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ChangePasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IChangePasswordResponse {
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}